import { cn } from "@/lib/utils";
import { statusFor, STATUS_BAR_BG, pct } from "@/lib/budget-status";

interface Props {
  /** Tildelte timer (oppgave eller tildeling) — nevner i prosent. */
  assigned: number;
  /** Faktisk forbrukte timer — teller i prosent. */
  used: number;
  /** Høyde i piksler (default 4 — slim "rolig" V3-stil). */
  height?: number;
  className?: string;
}

/**
 * Slim progress bar med statusfarge — speiler V3HoursBar i designprototypen.
 * Brukes per oppgave, per assignment og per fase i Timetildeling-tabellen.
 * Ingen flytende prosenttekst eller overshoot-stripe; selve fyllgraden
 * forteller historien.
 */
export function BudgetHoursBar({ assigned, used, height = 4, className }: Props) {
  const status = statusFor(assigned, used);
  const fillPct = pct(used, assigned);
  const isOver = used > assigned && assigned > 0;

  return (
    <div
      className={cn(
        "relative w-full overflow-hidden rounded-full bg-foreground/[0.06]",
        className,
      )}
      style={{ height }}
    >
      <div
        className={cn(
          "absolute left-0 top-0 bottom-0 rounded-full transition-all",
          STATUS_BAR_BG[status],
          !isOver && "opacity-75",
        )}
        style={{ width: `${Math.min(100, fillPct)}%` }}
      />
    </div>
  );
}
